module.exports = new __parcel__URL__("github-invertocat-logomark.268135a5.svg").toString();